import React from 'react';

function RoundAwarenessText() {
    return(
        <p className="GuideText"> Let's start to dive into some more specific topics within IGLing. First I'll start off by talking about Round awareness. To keep this as broad as possible, understanding how the round flow is working and  </p>
    )
}

export default RoundAwarenessText;